import _ from "lodash"
import * as actionUsers from "../store/actions/userActions"
import AvatorUrl from "../assets/images/user.jpg"
const isBrowser = typeof window !== `undefined`

/**
 * Local return current user data
 */
export const getloggedInUser = () => {
  const getUserObject = window.localStorage.getItem("loggedInUser")
  // console.log(getUserObject)
  if (getUserObject) {
    return JSON.parse(getUserObject)
  } else {
    return {}
  }
}

/**
 * Local return current user data
 */
export const getUser = (extractData = "attributes") => {
  const userObject = actionUsers.getUserData()
  if (extractData === "full") {
    return userObject
  }
  const extractObject = _.get(userObject, "data." + extractData)
  if (extractObject) {
    return extractObject
  } else {
    console.log("Data not found")
    return { val: "Data not found" }
  }
}

export const getCurrentUser = () => isBrowser && getUser()

/**
 * check is user loggedIn User
 */
export const isLoggedIn = () => {
  // if (!isBrowser) return false
  //const uid = getUser('id')
  const uid = actionUsers.getUUID()
  console.log("TCL: isLoggedIn -> uid", uid)
  return !!uid
}

/**
 * User logout and destroy user session
 */
export const logout = callback => {
  //if (!isBrowser) return
  actionUsers.destroyAuthSession()
  callback()
}

export const getAvator = () => {
  const profile_url = actionUsers.getAvatorImage()
  if (profile_url) {
    return profile_url
  } else {
    return AvatorUrl
  }
}

export const getAccessToken = () => {
  const accessToken = actionUsers.getSession()
  return accessToken
}
